module.exports = __webpack_public_path__ + "static/matza_2@2x-7835e6c5ad73f322f5a2072319e198f9.jpg";